import React from 'react';
import { Link } from 'gatsby';
import { Text, Flex, Box } from '../neta';
import PreviewImg from './PreviewImg';

export default class PreviewContainer extends React.Component {
  render() {
    const { large, post } = this.props;
    if (post === undefined) return null;

    return (
      <Link
        to={`${
          (post.__typename || '').toLowerCase().indexOf('podcast') != -1
            ? '/podcast'
            : '/articles'
        }/${post.slug}`}
        style={{ textDecoration: 'none' }}
      >
        <Flex flexDirection={['column', large ? 'column' : 'row']}>
          <Box>
            <PreviewImg alt={post.title} large={large} sizes={post.heroImage.sizes} />
          </Box>
          <Box
            flex="1"
            ml={[0, large ? 0 : 2]}
            pb={6}
            mb={6}
            borderBottom={large ? undefined : 'divider'}
          >
            <Box ml={[0, large ? 0 : 2]}>
              <Box mt={[3, large ? 3 : -1]} mb={3}>
                <Text.displayMedium fontWeight="bold" color="grayscale.black">
                  {post.title}
                </Text.displayMedium>
              </Box>
              <Text.body is="p" color="grayscale.black" mb={3}>
                {post.description}
              </Text.body>
              <Text.caption color="grayscale.stone">READ MORE</Text.caption>
            </Box>
          </Box>
        </Flex>
      </Link>
    );
  }
}
